<template>
  <EchartsLayout :option="option"></EchartsLayout>
</template>

<script>
import { getCacheOrRequest } from "@/utils/index.js";
import ComponentBase from "@/components/mixin/ComponentBase.vue";
import EchartsLayout from "@/components/common/EchartsLayout.vue";

export default {
  mixins: [ComponentBase],
  components: {
    EchartsLayout,
  },
  data() {
    return {
      option: null,
    };
  },
  methods: {
    get_component_data() {
      getCacheOrRequest.call(this, {
        method: "get",
        url: "/org/getCheckProportionTop",
        success: (response) => {
          let arr = [];
          response.data &&
            response.data.data &&
            response.data.data.map &&
            response.data.data.map((item) => {
              arr.push([item.orgName, item.checkProportion]);
            });

          // 更新配置
          this.option = {
            grid: { containLabel: true, right: 0, left: 0 },
            series: [
              {
                type: "bar",
                stack: "人数",
                showItemStyle: true,
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 1,
                    y2: 0,
                    colorStops: [
                      { offset: 1, color: "rgba(190, 227, 0, 1)" },
                      { offset: 0, color: "rgba(32, 179, 0, 1)" },
                    ],
                    globalCoord: false,
                  },
                  borderRadius: 50,
                },
                barWidth: 50,
              },
            ],
            title: { text: "单位：人", textStyle: { fontSize: 54 } },
            tooltip: { textStyle: { fontSize: 54 } },
            xAxis: {
              axisLabel: {
                textStyle: {
                  fontSize: 40,
                  fontWeight: 700,
                },
              },
            },
            yAxis: {
              type: "category",
              inverse: true,
              axisLabel: {
                textStyle: {
                  fontSize: 40,
                  fontWeight: 700,
                },
              },
            },
            dataset: {
              source: [["name", "入住率"], ...arr],
            },
          };
        },
      });
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped></style>
